import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col, Label, Progress } from "reactstrap";
import { LabelText } from "../Utils/Input";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { useDispatch, useSelector } from "react-redux";
import { getViewPartnerListing } from "../../slices/PartnerMangement/ViewListPartner/thunk";
import CommonButton from "../Utils/CommonButton";
import { useNavigate } from "react-router-dom";
import logoLarge from "../../assets/images/users/user-dummy-img.jpg";
import imagePlaceholder from "../../assets/images/image-placeholder.jpg";
import { viewDoc } from "../../slices/customer/documentview/thunk";

export const PartnerProfile = () => {
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const PartnerId = customerIdData();
    const [profileImage, setProfileImage] = useState(imagePlaceholder);

    // Get selectors
    let ViewListData = useSelector(state => state.PartnerViewList.partnerViewList);
    const ViewDocument = useSelector(state => state.ViewDocument.documentView);
    const base64ImageData = ViewDocument?.filePath || null;
    // Fetch partner listing data
    useEffect(() => {
        dispatch(getViewPartnerListing(setLoading, PartnerId));
    }, [dispatch, PartnerId]);

    useEffect(() => {
        if (ViewListData && ViewListData?.businessName) {
            const partnerOrCustomer = "Partner";
            dispatch(viewDoc(setLoading, PartnerId, "logo", partnerOrCustomer, setProfileData));
        }
    }, [dispatch, ViewListData, PartnerId]);

    useEffect(() => {
        if (ViewDocument && ViewDocument?.filePath) {
            setProfileImage(base64ImageData);
        }
    }, [ViewDocument]);

    const renderDoubleColumnRow = (leftLabel, leftValue, rightLabel, rightValue, noBorder = false) => {
        const formatValue = (label, value) => {
            if (!label) return '';
            return value ? value : 'N/A';
        };

        return (
            <div className={`d-flex mb-3 pb-2 ${noBorder ? '' : 'border-bottom'}`}>
                <div className="w-50 pe-3">
                    {leftLabel && <label className="fw-semibold">{leftLabel}</label>}
                    <p className="detail-value mb-0">{formatValue(leftLabel, leftValue)}</p>
                </div>
                <div className="w-50 ps-3">
                    {rightLabel && <label className="fw-semibold">{rightLabel}</label>}
                    <p className="detail-value mb-0">{formatValue(rightLabel, rightValue)}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="partner-profile-container py-2">
            <Row className="justify-content-center">
                <Col lg={9}>
                    <div className="d-flex flex-column flex-sm-row align-items-center mb-3 mb-md-0">
                        <img
                            src={profileImage}
                            className={`rounded-0 offer-bg-color img-thumbnail user-profile-image w-h-130`}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = imagePlaceholder;
                            }}
                            alt="user-profile"
                        />
                        <h3 className="text-black ms-4 my-3 my-sm-0 fw-bold align-self-center">
                            {`${""}`}
                        </h3>

                        {/* Wrap this whole section in a flex row and push the button right */}
                        <div className="d-flex justify-content-between align-items-center flex-grow-1 ">
                            <div>
                                <h4 className="mb-1 fw-bold text-black">{ViewListData?.businessName || "N/A"}</h4>
                                <p className="text-muted mb-0">Partner ID: {PartnerId || "N/A"}</p>
                            </div>
                            <div className="ms-n5">
                                <CommonButton
                                    color={"main-color"}
                                    className={
                                        "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                    }
                                    icon={<i className="bx bxs-edit label-icon align-middle fs-16 me-1"></i>}
                                    btnTxtClsName={"px-2 ps-1 ms-3 me-1"}
                                    type={"submit"}
                                    buttonAction={() => {
                                        navigate(`/update-partner/${PartnerId}`);
                                    }}
                                    buttonText={"Edit"}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rounded-1 px-3 py-3 my-2 bg-white">
                        <CardBody>
                            {/* Business Details Section */}
                            <div className="profile-details-section">
                                <p className="fs-5 fw-semibold mb-3 pb-2 border-bottom">Business Details</p>
                                {renderDoubleColumnRow("Business Name", ViewListData?.businessName, "Type", ViewListData?.type)}
                                {renderDoubleColumnRow("Partner ID", PartnerId, "Email Address", ViewListData?.emailAddress)}
                                {renderDoubleColumnRow(
                                    "Phone Number",
                                    `${ViewListData?.dialCode || ""}-${ViewListData?.mobile || ""}`,
                                    "Website Link",
                                    ViewListData?.websiteHref
                                )}
                                {renderDoubleColumnRow("Address 1", ViewListData?.addressLine1, "Address 2", ViewListData?.addressLine2)}
                                {renderDoubleColumnRow("City", ViewListData?.city, "State", ViewListData?.state)}
                                {renderDoubleColumnRow("Country", ViewListData?.country, "Zip Code", ViewListData?.zipcode, true)}

                                {/* Primary Contact Section */}
                                {ViewListData?.primaryContact && (
                                    <>
                                        <p className="fs-5 fw-semibold mt-4 mb-3 pb-2 border-bottom">Primary Contact</p>
                                        {renderDoubleColumnRow(
                                            "Contact Name",
                                            `${ViewListData?.primaryContact?.firstName || ""} ${ViewListData?.primaryContact?.lastName || ""}`.trim(),
                                            "Email Address",
                                            ViewListData?.primaryContact?.emailAddress
                                        )}
                                        {renderDoubleColumnRow(
                                            "Phone Number",
                                            `${ViewListData?.primaryContact?.dialCode || ""}-${ViewListData?.primaryContact?.mobile || ""}`,
                                            "",
                                            "",
                                            true
                                        )}
                                    </>
                                )}
                                <p className="fs-5 fw-semibold mt-4 mb-3 pb-2 border-bottom">Attributes</p>

                                {/* Attributes Section */}
                                {ViewListData?.characteristic?.map((attribute, index) => (
                                    <Row key={index} className="mb-3 ms-1">
                                        <Col md={6}>
                                            <Row>
                                                <div className="col">{attribute?.name}</div>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <div className="col">{attribute?.value}</div>
                                            </Row>
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        </CardBody>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default PartnerProfile;